var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("preloader", { attrs: { display: !_vm.isSettingsLoaded } }),
      _vm._v(" "),
      _c(
        "Card",
        [
          _c(
            "div",
            { staticClass: "email-settings" },
            [
              _vm.isSetup
                ? _c(
                    "h3",
                    {
                      staticClass:
                        "email-settings__subtitle typographies-heading-h3"
                    },
                    [
                      _c("span", [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.$l10n.__(
                                "Informations sur votre compte email"
                              )
                            ) +
                            "\n                "
                        )
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isSettingsLoaded
                ? [
                    !_vm.isSetup
                      ? _c(
                          "div",
                          [
                            _c(
                              "EmailSettingAccountNotSynced",
                              _vm._b(
                                {
                                  attrs: {
                                    isEmailsSentFromCorp:
                                      _vm.isEmailsSentFromCorp
                                  }
                                },
                                "EmailSettingAccountNotSynced",
                                _vm.account,
                                false
                              )
                            )
                          ],
                          1
                        )
                      : _c(
                          "div",
                          [
                            _vm.isSyncMode
                              ? _c(
                                  "EmailSettingAccountSynced",
                                  _vm._b(
                                    {
                                      attrs: {
                                        isEmailsSentFromCorp:
                                          _vm.isEmailsSentFromCorp
                                      },
                                      on: {
                                        updateEmailStatus: _vm.getSettings,
                                        handleDisplayDialog:
                                          _vm.handleDisplayDisconnectPopup
                                      }
                                    },
                                    "EmailSettingAccountSynced",
                                    _vm.account,
                                    false
                                  )
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("EmailSettingPreferences", {
                              attrs: { defaultValues: _vm.defaultValues }
                            })
                          ],
                          1
                        )
                  ]
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _vm.showDisconnectPopup
            ? _c("disconnect-popup", {
                attrs: { visible: _vm.showDisconnectPopup },
                on: {
                  close: _vm.handleCloseDialog,
                  handleDisconnect: _vm.logout
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }